import React from 'react';
type BarChartProps = {
  labels: string[];
  values: number[];
  height: number;
  color: string;
};
export const BarChart: React.FC<BarChartProps> = ({
  labels,
  values,
  height,
  color
}) => {
  const maxValue = Math.max(...values) * 1.1; // Add 10% padding
  return <div style={{
    height: `${height}px`
  }} className="relative" data-id="element-451">
      <div className="flex items-end h-full space-x-2" data-id="element-452">
        {labels.map((label, index) => <div key={index} className="flex-1 flex flex-col items-center" data-id="element-453">
            <div className="w-full rounded-t-md transition-all duration-300 hover:opacity-80" style={{
          height: `${values[index] / maxValue * 100}%`,
          backgroundColor: color
        }} data-id="element-454"></div>
            <div className="mt-2 text-xs text-gray-500 truncate w-full text-center" data-id="element-455">
              {label}
            </div>
          </div>)}
      </div>
      {/* Y-axis lines */}
      <div className="absolute inset-0 flex flex-col justify-between pointer-events-none" data-id="element-456">
        {[0, 1, 2, 3, 4].map(i => <div key={i} className="border-b border-gray-100 w-full h-0" data-id="element-457"></div>)}
      </div>
    </div>;
};